import { AppView } from '../'
import { branch, memberKey } from '../constants'

module.exports = () ->

  try
    appView = await new Weaver.Query(undefined, branch).restrict('AppView').first()
  catch
    appView = undefined

  try
    graphView = await new Weaver.Query(undefined, branch).restrict('GraphView').first()
  catch
    graphView = new Weaver.Node('GraphView')
    await graphView.save({ branch, commitMessage: "GraphView type created."})

  toMigrate = await AppView.list({ authenticated: true })
  await appView.destroy(undefined, undefined, undefined, undefined) if appView?

  toMigrate.map((configNode) ->
    configNode.relation(memberKey).add(graphView)

    treeQuery = configNode.get('query')
    graphQuery = configNode.get('graphQuery')

    configNode.unset('graphQuery')
    configNode.set('treeQuery', treeQuery)
    configNode.set('query', graphQuery)

    configNode.save({ branch, commitMessage: "AppView -> GraphView migration." })
  )
